// TODO: just for the demo purpose, this file will be removed
import React from "react";
import UniversalTable from "../UniversalTable";
import { demoColumns, demoData } from "./tableDemoData";

const TableDemoView = () => {
    return <UniversalTable title="Table demo" columns={demoColumns} data={demoData} searchable />;
};

export default TableDemoView;
